/* eslint-disable no-param-reassign */
import * as utils from '../../../../util';
import type { Data } from '../../specProcessor';
import type { StandardChartLayerSpec } from '../../../../core/layer';
import type { Spec as RankingHorizontalBarLayerSpec } from '../../../../layer/preset/bar/rankingHorizontalBar';
import {
  BaseSpec,
  ILayerTypeSpec,
  createDataTypeValidator,
  createEncodingValidator,
  createLayerProcessor
} from '../baseProcessor';

export type Spec = BaseSpec;

// 扩展ILayerTypeSpec以包含__isEncodingValid属性
interface RankingHorizontalBarLayerTypeWithFields extends ILayerTypeSpec {
  __isEncodingValid?: boolean;
}

type RankingHorizontalBarLayerType = StandardChartLayerSpec &
  RankingHorizontalBarLayerSpec &
  RankingHorizontalBarLayerTypeWithFields;

// 创建排名水平条形图数据类型验证器
const validateRankingHorizontalBarDataTypes = createDataTypeValidator('rankingHorizontalBar', [
  { field: 'x', type: 'number' },
  { field: 'y', type: 'string' }
]);

// 创建排名水平条形图编码验证器
const validateRankingHorizontalBarEncoding = createEncodingValidator([
  { field: 'x' },
  { field: 'y' }
]);

// 额外的检查函数 - 验证数据量是否满足要求
const additionalRankingHorizontalBarChecks = (layer: RankingHorizontalBarLayerType, data: Data) => {
  const { dataIndex = 0, encoding } = layer;
  const values = data[dataIndex]?.values || [];

  if (values.length <= 1) {
    utils.logger.warn(
      'warning',
      `The data amount of the "${layer.type}" layer must be greater than 1`
    );
    layer.__isEncodingValid = false;
  }

  // 检查X轴数据量
  const xValues = new Set(values.map(item => item[encoding.x]));
  if (xValues.size <= 1) {
    utils.logger.warn(
      'warning',
      `The amount of "${encoding.x}" values must be greater than 1 for "${layer.type}" layer`
    );
    layer.__isEncodingValid = false;
  }

  // 检查Y轴数据量
  const yValues = new Set(values.map(item => item[encoding.y]));
  if (yValues.size <= 3) {
    utils.logger.warn(
      'warning',
      `The amount of "${encoding.y}" values must be greater than 3 for "${layer.type}" layer`
    );
    layer.__isEncodingValid = false;
  }
};

// 创建并导出排名水平条形图处理器
export const rankingHorizontalBar = createLayerProcessor<RankingHorizontalBarLayerType>(
  'rankingHorizontalBar',
  validateRankingHorizontalBarEncoding,
  validateRankingHorizontalBarDataTypes,
  additionalRankingHorizontalBarChecks
);
